import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import ControlButtonDropdown from 'components/atoms/controlPanelDropdownButton/controlButtonDropdown';
import ControlPanelSuccessIcon from 'components/atoms/icons/controlPanelSuccessIcon';
import PatientControlButton from 'components/atoms/patentControlButton';
import { clinicReviewTimesDataSource } from 'infrastructure/data-sources/clinic-review-times';

import s from './styles.module.scss';

interface IProps {
  value: number | null;
  readonly?: boolean;
  onChange?: (value: number) => void;
}

const ClinicReviewTimeControlButton: React.FC<IProps> = (props) => {
  const { value, readonly, onChange } = props;

  const [opened, setOpened] = useState(false);

  const { t } = useTranslation();

  const items = clinicReviewTimesDataSource();

  const options = readonly
    ? []
    : items.map((el) => ({
        id: el.id as number,
        value: el.id,
        label: el.name,
      }));

  const selectedValue = useMemo(() => {
    const val = items.find((el) => el.id === value);
    return val ?? items[0];
  }, [value, items]);

  const ToggleButton = (
    <PatientControlButton
      label={t('labels.clinicReviewTime')}
      status={selectedValue.name}
      Icon={ControlPanelSuccessIcon}
      handleClick={() => setOpened(!opened)}
    />
  );

  const handleChange = (val: number) => {
    if (onChange) onChange(val);
    setOpened(false);
  };

  return (
    <div className={classNames(readonly && s.readonly)}>
      <ControlButtonDropdown
        toggleBtn={ToggleButton}
        options={options}
        handleOptionClick={handleChange}
      />
    </div>
  );
};

export default ClinicReviewTimeControlButton;
